import React, { useEffect } from 'react'
import { IoClose } from 'react-icons/io5';
import '../../src/assets/style/component-styles/notification.scss'
import logo from "../../src/assets/images/logo/logo.png"
import { FaRegFile } from 'react-icons/fa6';
import pcw from "../assets/images/activities/50-50-pcw.png";
import pcn from "../assets/images/activities/50-50-pcn.png";
import { checkTheme } from '../utils/utils';

const Pushnotification = ({ title, body, onClose }) => {

    const isFile = (body) => {
        if (typeof body === "string") {
            const fileExtensions = [".jpeg", ".jpg", ".png", ".pdf", ".docx", ".xlsx"];
            return fileExtensions.some((ext) => body.endsWith(ext));
        }
        return false;
    };

    useEffect(() => {

        const timer = setTimeout(() => {
            onClose();
        }, 9000);

        return () => clearTimeout(timer);
    }, [onClose]);

    return (
        <>
            <section className='pushnotifca'>
                <div className='notify'>
                    <img src={checkTheme() ? pcn : pcw} alt="icon" /> 
                    <div className="notify-content">
                        <h4 className="notify-title">{title}</h4>
                        <p className="notify-body">
                            {isFile(body) ? (
                                <>
                                    <FaRegFile color='var(--sandy-brown)' size={24} />
                                    <span>File Received</span>
                                </>
                            ) : (
                                body
                            )}
                        </p>
                    </div>
                    <button className="notify-close" onClick={onClose}>
                        <IoClose />
                    </button>
                </div>
            </section>
        </>
    )
}

export default Pushnotification
